module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-BoldItalic.a0b29aed.woff";